import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import * as React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import {
    AlertProvider,
    ClientShopsProvider,
    DomainContextProvider,
    SocketProvider,
    UnreadMessagesProvider,
    UserProvider,
} from '../context';
import { BreadCrumbsProvider } from '../context/BreadCrumbsContext';
import { StatusProvider } from '../context/StatusContext';
import { ChurnZeroProvider } from '../context/churnZeroContext';
import { ClientStatusProvider } from '../context/clientStatusContext';
import { FeatureFlagsProvider } from '../context/featureFlagsContext';
import { FeatureUsageProvider } from '../context/featureUsageContext';
import { TtsSellerProvider } from '../context/TtsSellerProvider';
import { PostHogProvider } from '../context/posthog';
import ErrorBoundary from './ErrorBoundary';
import { ContactsProvider } from './Hub/Contacts/ContactsContext';
import { UploadWizardProvider } from './Hub/Contacts/UploadWizard/UploadWizardContext';
import { SuspensionBannerProvider } from '../context/SuspensionBannerContext';

const queryClient = new QueryClient();

const AppProviders: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <QueryClientProvider client={queryClient}>
        <PostHogProvider>
            <UserProvider>
                <SocketProvider>
                    <UnreadMessagesProvider>
                        <DomainContextProvider>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DndProvider backend={HTML5Backend}>
                                    <ClientShopsProvider>
                                        <FeatureFlagsProvider>
                                            <ClientStatusProvider>
                                                <FeatureUsageProvider>
                                                    <TtsSellerProvider>
                                                        <SuspensionBannerProvider>
                                                            <ChurnZeroProvider>
                                                                <AlertProvider>
                                                                    <StatusProvider>
                                                                        <ContactsProvider>
                                                                            <UploadWizardProvider>
                                                                                <BreadCrumbsProvider>
                                                                                    <ErrorBoundary>
                                                                                        {children}
                                                                                    </ErrorBoundary>
                                                                                </BreadCrumbsProvider>
                                                                            </UploadWizardProvider>
                                                                        </ContactsProvider>
                                                                    </StatusProvider>
                                                                </AlertProvider>
                                                            </ChurnZeroProvider>
                                                        </SuspensionBannerProvider>
                                                    </TtsSellerProvider>
                                                </FeatureUsageProvider>
                                            </ClientStatusProvider>
                                        </FeatureFlagsProvider>
                                    </ClientShopsProvider>
                                </DndProvider>
                            </LocalizationProvider>
                        </DomainContextProvider>
                    </UnreadMessagesProvider>
                </SocketProvider>
            </UserProvider>
        </PostHogProvider>
    </QueryClientProvider>
);

export default AppProviders;
